module.exports = __webpack_public_path__ + "img/logo-192x192.8f8550e9.png";